export function waitFor(t = 0) {
  return new Promise((r) => setTimeout(() => r(null), t))
}
